import React, { useCallback } from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { useTempState } from '@starflow/app/store';
import { CustomModelCard } from '@starflow/app/modules/generator/components/_legacy/model';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { BASETYPE_VALUE_TO_SHORT_LABEL } from '@shakkerai/pro-models';
import { pickLora } from '../../../models/helpers';

export const Lora = React.memo((props) => {
  const { title, name, value, onChange } = props;

  const handlePickModel = useCallback(() => {
    pickLora(value, `model-pick-button-${name}`, (modelData) => {
      onChange(modelData, name);
    });
  }, [value, name, onChange]);

  return (
    <div data-trigger-window="model-loras" id={`model-pick-button-${name}`}>
      <div className="mb-1">
        <span className="text-xs text-[#7f7f7f] leading-[14px]">{title}</span>
      </div>
      {value ? (
        value.error ? (
          <div
            onClick={handlePickModel}
            className="flex items-center justify-center h-[50px] bg-[#f4f6f8] hover:bg-[#f0f2f4] rounded cursor-pointer"
          >
            <span className="text-xs text-amber-600">{`${value.error}`}</span>
          </div>
        ) : (
          <div onClick={handlePickModel} className="cursor-pointer">
            <CustomModelCard data={value} />
          </div>
        )
      ) : (
        <div
          onClick={handlePickModel}
          className="flex items-center justify-center h-[50px] bg-[#f4f6f8] hover:bg-[#f0f2f4] rounded cursor-pointer"
        >
          <Icon className="shk-zoomin" fontSize={18} color="#444" />
          <span className="ml-1 text-xs text-[#444] font-semibold translate-y-[0.5px]">
            {translate('workflow_model_picker')}
          </span>
        </div>
      )}
    </div>
  );
});

export const LoraView = React.memo(({ value: lora }) => {
  const isSimple = useTempState('globalMode') === 'simple';
  return (
    <>
      <div className="p-4">
        <div className="flex items-center justify-between h-5">
          <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs leading-[14px] font-bold font-gro">
            {translate('model_title_lora')}
            <span className="text-[#b2b2b2]">&ensp;LoRA</span>
          </h5>
        </div>
        <div className="flex flex-col items-strength space-y-1 mt-2">
          <div className="relative flex items-center -mx-2 p-2 hover:bg-[#f8f8f8] rounded">
            <div className="flex-shrink-0 relative h-[52px] w-[40px] overflow-hidden rounded group">
              <img className="h-full w-full object-cover" src={convert2CompressedUrl(lora?.imageUrl, 80)} />
              {!!lora?.versionName && (
                <span className="absolute bottom-0 right-0 left-0 h-4 bg-black/40 backdrop-blur text-center text-xs text-white">
                  {lora?.versionName}
                </span>
              )}
            </div>

            <div className="flex-1 flex flex-col items-stretch ml-2 overflow-hidden">
              <div className="flex items-center">
                <span className="flex-1 text-[#2d2d2d] whitespace-nowrap text-ellipsis overflow-hidden text-xs">
                  {lora?.name}
                </span>
              </div>
              <div className="flex items-center mt-2">
                <span className="text-xs text-[#8c8c8c]">{lora?.weight}</span>
                {!isSimple && (
                  <>
                    <div className="w-px h-2.5 mx-2 bg-[#efefef]" />
                    <span className="text-xs text-[#8c8c8c]">
                      {`${BASETYPE_VALUE_TO_SHORT_LABEL[lora?.baseType] || lora?.baseType}`.replace(/\s/g, '')}
                    </span>
                  </>
                )}
                {lora?.vipUsed === 1 && <div className="w-px h-2.5 mx-2 bg-[#efefef]" />}
                {/* {lora?.vipUsed === 1 && <img src={crownIcon} className="w-[13px]" alt="" />} */}
              </div>
            </div>

            {/* <button
              onClick={() => onApplyLora?.(lora)}
              className="flex-shrink-0 w-12 h-6 ml-4 px-2 text-[#005848] text-xs font-normal bg-[#00FFD615] border border-[#2EE8C7] rounded-sm"
            >
              {translate('common_use')}
            </button> */}
          </div>
        </div>
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
